import React from "react";

export const LadderProfilerIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.32"
      d="M1.5207 13.1049C1.57981 13.6773 1.95511 14.1304 2.51796 14.2503C3.40637 14.4394 5.08111 14.6666 8.00004 14.6666C10.919 14.6666 12.5937 14.4394 13.4821 14.2503C14.045 14.1304 14.4203 13.6773 14.4794 13.1049C14.567 12.2562 14.6667 10.6979 14.6667 7.99992C14.6667 5.30195 14.567 3.74365 14.4794 2.89493C14.4203 2.32251 14.045 1.86941 13.4821 1.74959C12.5937 1.56046 10.919 1.33325 8.00004 1.33325C5.08111 1.33325 3.40637 1.56046 2.51796 1.74959C1.95511 1.86941 1.57981 2.32251 1.5207 2.89493C1.43305 3.74365 1.33337 5.30195 1.33337 7.99992C1.33337 10.6979 1.43305 12.2562 1.5207 13.1049Z"
      fill="#078DEE"
    />
    <path
      d="M9.29215 9.23723C10.1753 8.77217 10.7775 7.8453 10.7775 6.77777C10.7775 5.24367 9.53388 4 7.99975 4C6.46565 4 5.22198 5.24367 5.22198 6.77777C5.22198 7.84533 5.82421 8.77227 6.70748 9.2373C5.52465 9.68797 4.62148 10.7395 4.34171 12.0353C4.30301 12.2146 4.40168 12.3987 4.58231 12.4314C5.23058 12.5487 6.30415 12.6667 8.00045 12.6667C9.69671 12.6667 10.7703 12.5487 11.4185 12.4314C11.5985 12.3988 11.6969 12.2154 11.6584 12.0367C11.379 10.7402 10.4755 9.68803 9.29215 9.23723Z"
      fill="#078DEE"
    />
  </svg>
);
